import * as React from "react"
import { Switch as BaseSwitch } from "@base-ui/react/switch"
import { cn } from "@lib/cn"

export interface SwitchProps extends React.ComponentPropsWithoutRef<typeof BaseSwitch.Root> {
  size?: "sm" | "md"
}

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  ({ className, size = "md", ...props }, ref) => (
    <BaseSwitch.Root
      ref={ref}
      className={cn(
        "relative inline-flex shrink-0 cursor-pointer rounded-pill border-2 border-transparent outline-none",
        "transition-colors duration-quick ease-out-quad motion-reduce:transition-none",
        "bg-cloverhound-gray-300 dark:bg-cloverhound-gray-700",
        "focus-visible:ring-2 focus-visible:ring-cloverhound-indigo-500 focus-visible:ring-offset-2",
        "focus-visible:ring-offset-cloverhound-gray-50 dark:focus-visible:ring-offset-cloverhound-gray-950",
        "data-[checked]:bg-cloverhound-indigo-600",
        "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50",
        size === "sm" ? "h-4 w-7" : "h-5 w-9",
        className,
      )}
      {...props}
    >
      <BaseSwitch.Thumb
        className={cn(
          "pointer-events-none block rounded-pill bg-white shadow-sm ring-0",
          "transition-transform duration-quick ease-out-quad motion-reduce:transition-none",
          size === "sm" ? "size-3" : "size-4",
          size === "sm" ? "data-[checked]:translate-x-3" : "data-[checked]:translate-x-4",
        )}
      />
    </BaseSwitch.Root>
  ),
)
Switch.displayName = "Switch"
